import { MultiselectCategoryCardComponent } from '../../../login/createaccountcomponent/categorylist/viewmodel/categorycard/multiselectcategorycardcomponent';
import { BaseContext } from '../../../../../utils/basecontext';
import { UIComponentHandler, UIDataModel } from '../../../../toolkit/uicomponent';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';
import { PreferenceCategoryCardViewImpl } from './preferencecategorycardview';
import { PreferenceCategoryCardCSSStyleImpl } from './preferencecategorycardcssstyle';


export class PreferenceCategoryCardComponent extends MultiselectCategoryCardComponent
{
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new PreferenceCategoryCardViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new PreferenceCategoryCardCSSStyleImpl(applicationContext);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/myaccount/preferences/preferenccard/preferencecategorycardcomponent.tsx